import { CookieConsent } from '../contexts/CookieConsentContext';

export const blockExternalScripts = () => {
  const scripts = document.querySelectorAll('script[src]');
  scripts.forEach(script => {
    const src = script.getAttribute('src');
    if (src && (
      src.includes('facebook') ||
      src.includes('analytics') ||
      src.includes('gtag') ||
      src.includes('googletagmanager') ||
      src.includes('google-analytics')
    )) {
      script.remove();
    }
  });
};




export const clearCookies = (categories: (keyof CookieConsent)[]) => {
  const cookies = document.cookie.split(';');
  
  cookies.forEach(cookie => {
    const [name] = cookie.split('=');
    const cookieName = name.trim();
    
    categories.forEach(category => {
      if (shouldBlockCookie(cookieName, category)) {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });
  });
};

const shouldBlockCookie = (cookieName: string, category: keyof CookieConsent): boolean => {
  const cookiePatterns = {
    analytics: [
      '_ga', '_gid', '_gat', '__utma', '__utmb', '__utmc', '__utmt', '__utmz',
      '_gtag', '_gcl_au', '_fbp', '_fbc'
    ],
    marketing: [
      '__fb', '_fbp', '_fbc', 'fr', 'tr', '_gcl_', 'IDE', 'test_cookie',
      '_pinterest', '_pin_unauth', '_routing_id', 'ads'
    ],
    preferences: [
      'lang', 'language', 'theme', 'locale', 'timezone', 'currency'
    ]
  };

  const patterns = cookiePatterns[category as keyof typeof cookiePatterns] || [];
  return patterns.some(pattern => cookieName.toLowerCase().includes(pattern.toLowerCase()));
};

export const clearStorageData = (categories: (keyof CookieConsent)[]) => {
  categories.forEach(category => {
    if (category === 'analytics' || category === 'marketing') {
      Object.keys(localStorage).forEach(key => {
        if (key.includes('ga') || key.includes('gtag') || key.includes('fb') || key.includes('analytics')) {
          localStorage.removeItem(key);
        }
      });

      Object.keys(sessionStorage).forEach(key => {
        if (key.includes('ga') || key.includes('gtag') || key.includes('fb') || key.includes('analytics')) {
          sessionStorage.removeItem(key);
        }
      });
    }
  });
};